import React from 'react';

const COUNTRY_CODES = {
  'Canada': 'ca',
  'Cameroun': 'cm',
  'France': 'fr',
  'Sénégal': 'sn',
  "Côte d'Ivoire": 'ci',
  'Maroc': 'ma',
  'États-Unis': 'us',
  'Belgique': 'be',
  'Suisse': 'ch',
  'Allemagne': 'de',
  'Mali': 'ml',
  'Algérie': 'dz',
  'Tunisie': 'tn',
  'Royaume-Uni': 'gb',
  'Espagne': 'es',
  'Italie': 'it',
  'Gabon': 'ga',
  'Congo': 'cg',
  'RD Congo': 'cd',
  'Burkina Faso': 'bf',
  'Niger': 'ne',
  'Togo': 'tg',
  'Bénin': 'bj',
};

export const flag = (country) => {
  if (!country) return null;
  const code = COUNTRY_CODES[country];
  if (!code) return null;
  return React.createElement('img', {
    src: `https://flagcdn.com/w40/${code}.png`,
    srcSet: `https://flagcdn.com/w40/${code}.png 1x, https://flagcdn.com/w80/${code}.png 2x`,
    alt: country,
    width: 20,
    height: 15,
    style: { display: 'inline-block', verticalAlign: 'middle', marginRight: '4px', borderRadius: '2px' },
    loading: 'lazy',
  });
};
